(() => {
  'use strict';
  const link = document.querySelector('.vr-whatsapp-float');
  if (!link) return;
  let queued = false;
  const observed = new WeakSet();
  const resize = new ResizeObserver(() => schedule());
  const position = () => {
    queued = false;
    let offset = innerWidth < 768 ? 18 : 24;
    const bottomBars = document.querySelectorAll('iframe[src*="preview-bar"],iframe[id*="preview-bar"],.product-cart-sticky.active');
    bottomBars.forEach(candidate => {
      // Shopify's full-height preview iframe is clipped by its bottom wrapper.
      const bar = candidate.closest('#PBarNextFrameWrapper') || candidate;
      if (!observed.has(bar)) { resize.observe(bar); observed.add(bar); }
      const rect = bar.getBoundingClientRect();
      const style = getComputedStyle(bar);
      if (rect.height < 1 || rect.height > innerHeight / 2 || style.display === 'none' || style.visibility === 'hidden') return;
      const linkRight = innerWidth - (innerWidth < 768 ? 16 : 24);
      const linkLeft = linkRight - link.offsetWidth;
      if (rect.right > linkLeft && rect.left < linkRight && rect.top >= 0 && rect.top < innerHeight && rect.bottom > innerHeight / 2) {
        offset = Math.max(offset,innerHeight - rect.top + 14);
      }
    });
    link.style.bottom = `calc(${Math.round(Math.min(offset, Math.max(18, innerHeight - link.offsetHeight - 18)))}px + env(safe-area-inset-bottom, 0px))`;
  };
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(position); } }
  addEventListener('resize',schedule,{passive:true});
  new MutationObserver(records => {
    const relevant = records.some(record => record.type === 'attributes'
      ? record.target.matches('product-cart-sticky,iframe,#PBarNextFrameWrapper')
      : [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('product-cart-sticky,iframe,#PBarNextFrameWrapper') || node.querySelector?.('product-cart-sticky,iframe,#PBarNextFrameWrapper'))));
    if (relevant) { schedule(); setTimeout(schedule,650); }
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
  schedule();
})();
